import React from "react";
import { ChipInput } from "../ChipInput";
import {
  DescriptionField,
  DetailsPanel,
  FieldError,
  FieldGroup,
  FieldLabel,
  KeyQuestionsSection,
} from "./DataStudioColumnDetailsForm.styles";
import type { DataStudioColumnDetailsFormProps } from "./DataStudioColumnDetailsForm.types";

export const DataStudioColumnDetailsForm: React.FC<
  DataStudioColumnDetailsFormProps
> = ({
  description,
  onDescriptionChange,
  synonyms,
  synonymsDraft,
  synonymsInputError,
  onSynonymsChange,
  onSynonymsKeyDown,
  onSynonymsBlur,
  onRemoveSynonym,
  notes,
  noteInput,
  onNoteInputChange,
  onNoteKeyDown,
  onRemoveNote,
  disabled = false,
  descriptionError,
  synonymsError,
}) => (
  <DetailsPanel aria-label="Editable column details">
    <DescriptionField
      id="column-details-description"
      label="Description"
      value={description}
      rows={4}
      resize="none"
      disabled={disabled}
      error={Boolean(descriptionError)}
      aria-describedby={
        descriptionError ? "column-details-description-error" : undefined
      }
      onChange={(event) => onDescriptionChange(event.target.value)}
    />
    {descriptionError ? (
      <FieldError id="column-details-description-error" role="alert">
        {descriptionError}
      </FieldError>
    ) : null}
    <FieldGroup>
      <FieldLabel as="span">Synonyms</FieldLabel>
      <ChipInput
        values={synonyms}
        draft={synonymsDraft}
        error={synonymsInputError || Boolean(synonymsError)}
        errorText={synonymsError}
        placeholder="Type a synonym and press Enter"
        ariaLabel="Synonyms"
        disabled={disabled}
        onChange={onSynonymsChange}
        onKeyDown={onSynonymsKeyDown}
        onBlur={onSynonymsBlur}
        onRemove={onRemoveSynonym}
      />
    </FieldGroup>
    <KeyQuestionsSection
      title="Notes"
      keyAreas={notes.map((note, index) => ({
        id: String(index),
        text: note,
      }))}
      keyAreaInput={noteInput}
      onKeyAreaInputChange={onNoteInputChange}
      onKeyAreaKeyDown={onNoteKeyDown}
      onRemoveKeyArea={(id) => onRemoveNote(Number(id))}
      disabled={disabled}
      scrollable
    />
  </DetailsPanel>
);

export default DataStudioColumnDetailsForm;
